import React, { useRef, useState, useCallback } from 'react';
import { Form } from '@unform/web';
import TableLoader from '../TableLoader';
import Modal from '../Modal';
import { Container } from './styles';

interface ConfirmationModalProps {
  show: boolean;
  title: string;
  text: string;
  handleClose(): void;
  handleSuccess(): void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  handleClose,
  handleSuccess,
  title,
  text,
}) => {
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(async () => {
    setLoading(true);
    await handleSuccess();
    setLoading(false);
    handleClose();
  }, []);

  return (
    <Container>
      <Modal title={title} handleClose={handleClose} show={show}>
        {loading ? (
          <TableLoader />
        ) : (
          <>
            <p className="bodyText">{text}</p>
            <Form ref={formRef} onSubmit={handleSubmit}>
              <div className="buttonsContainer">
                <button className="no" type="button" onClick={handleClose}>
                  Não
                </button>
                <button className="button" type="button" onClick={handleSubmit}>
                  Sim
                </button>
              </div>
            </Form>
          </>
        )}
      </Modal>
    </Container>
  );
};

export default ConfirmationModal;
